import Chapter, { FadeIn } from "./Chapter";

const RULES = [
  { no: "I", text: "Housemade salsa with real complexity and character." },
  { no: "II", text: "Fresh tortillas — corn or flour — made with care." },
  { no: "III", text: "Meat that tastes like someone cared about the marinade." },
];

export const Standard = () => (
  <>
    <Chapter no="08" kicker="Conclusion" title="The Pranjal Approved Standard" id="the-standard" />
    <section className="px-4 sm:px-8 pb-24" data-testid="standard-section">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7">
          {RULES.map((r, i) => (
            <FadeIn key={r.no} delay={i * 0.08} className="flex gap-6 border-b border-ink/20 py-6 items-baseline">
              <span className="font-serif italic text-salsa text-2xl sm:text-3xl w-10 shrink-0">{r.no}</span>
              <p className="font-serif font-medium text-2xl sm:text-4xl leading-tight">{r.text}</p>
            </FadeIn>
          ))}
          <FadeIn delay={0.2} className="mt-8 font-body text-base md:text-lg leading-relaxed text-ink2 max-w-2xl space-y-5">
            <p>
              Every spot scoring 8.5 or above meets all three requirements. Spots that don't —
              regardless of online stars — don't make the list. Austin's extraordinary tacos are made
              by families and immigrants who learned from grandmothers in Jalisco, Veracruz, Matamoros,
              and Guanajuato.
            </p>
            <p className="text-ink font-medium">
              Find them. Tell your friends. Leave reviews. Tip well.
            </p>
          </FadeIn>
        </div>
        <FadeIn delay={0.15} className="lg:col-span-5">
          <div className="border-2 border-ink p-8 bg-paper2 relative" data-testid="author-card">
            <span className="stamp text-[10px] absolute -top-3 right-6 bg-paper">Pranjal Approved</span>
            <p className="font-mono text-[9px] tracking-[0.22em] uppercase text-muted2 mb-4">About the Author</p>
            <p className="font-serif font-semibold text-3xl">Pranjal Katare</p>
            <p className="mt-4 font-body text-sm md:text-base leading-relaxed text-ink2">
              Recent graduate of The University of Texas at Austin, Econometrics &amp; Quantitative
              Economics. This research is the analytical foundation of Pranjal's Taco Spots — a
              platform dedicated to promoting authentic, locally owned taquerias across Austin and
              beyond.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>

    <footer className="border-t-2 border-ink px-4 sm:px-8 py-10" data-testid="footer">
      <div className="flex flex-col lg:flex-row justify-between gap-8">
        <div>
          <p className="font-serif font-semibold text-2xl">The Austin Taco Index</p>
          <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-muted2 mt-2">
            Authenticity, Salsa, and the Business of the Perfect Taco
          </p>
        </div>
        <div className="font-mono text-[10px] tracking-[0.12em] uppercase text-muted2 space-y-1.5 lg:text-right">
          <p>Data — The Austin Taco Index field study</p>
          <p>Photos & ratings — Google Maps</p>
          <p>Cartography — OpenStreetMap · Esri</p>
          <p>Type — Cormorant Garamond · Space Mono · Spectral</p>
          <p className="text-salsa">Austin, Texas — Vol. 01</p>
        </div>
      </div>
    </footer>
  </>
);

export default Standard;
